import { Check } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import css from './styles.module.css'

export const CheckAccessory: React.FC = () => (
  <div className={css.check_accessory}>
    <Check />
  </div>
)
